import { setFontScale } from 'mini-app-module-store/lib/mutator/setFontScale';
import { setFontSize } from '../mutators/setFontSize';
import { setFontSizeOnDocument } from './setFontSizeOnDocument';
import type { FontSize } from '../schema/FontSize';

/**
 * Updates font size in the store and set the css variables on the document
 */
export const loadDisplay = (fontSize: FontSize): void => {
    // Update store
    setFontSize(fontSize);

    // Update font scale this updates item height in Mail List
    setFontScale(fontSize);

    // Update document
    setFontSizeOnDocument();
};
